import {
    AnnualPolicyInfo,
    PaymentCard,
    ProductsEnum,
} from "@ferry/journey-services";
import * as React from "react";
import {Link} from "react-router-dom";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";
import type {ICustomerPortalService} from "../../services/ICustomerPortalService";
import {Types} from "../../Types";
import {WarningBanner} from "@ferry/portal-core";

interface IProps {
    unpaidChargebackInvoiceInfo: any;
    policyNumber: string;
    product: ProductsEnum;
}

interface IState {
    reuseCard?: boolean
}

export class OutstandingPaymentBanner extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: any) {
        super(props);
        this.state = {}
    }

    public componentDidMount(): void {
        this.customerPortalService.getPolicyPropertyMainAnnualPaymentCard(this.props.policyNumber).subscribe(
            (paymentCardId: number) => {
                this.customerPortalService.getAnnualPolicyInfo(this.props.policyNumber).subscribe((annualPolicyInfo: AnnualPolicyInfo) => {
                    if (paymentCardId && annualPolicyInfo?.paymentCards) {
                        const mainCards: PaymentCard[] = annualPolicyInfo.paymentCards.filter(c => c.id === paymentCardId);

                        if (mainCards) {
                            this.setState({
                                reuseCard: mainCards[0].reuseCard
                            })
                        }
                    }
                });
            }
        );
    }

    public render(): React.ReactNode {
        // there could be crazy scenarios with multiple invoices, but there is agreement to not cover those for now
        const [invoiceId, amount] = Object.entries(this.props.unpaidChargebackInvoiceInfo ?? {})[0] ?? [];

        return (
            <div className="inner-container">
                <WarningBanner wording={
                    <>
                        You have an outstanding balance of{' '}
                        <span className="font-weight-bold">{getAmountWithDecimalDigits(amount)}</span>.
                        <div>
                            <Link id="payNow"
                                  className="btn btn-white-dashboard"
                                  state={{
                                      verifyCardFailed: false,
                                      product: this.props.product
                                  }}
                                  to={{
                                      pathname: `/dashboard/account/outstandingPayment/${this.props.policyNumber}/${invoiceId}`,
                                  }}>
                                Pay {getAmountWithDecimalDigits(amount)} now
                            </Link>
                        </div>
                    </>
                }/>
            </div>
        );
    }
}
